var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoFactor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:security"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3039 17.3047C9.91391 16.9547 8.76631 16.1571 7.86111 14.9119C6.95591 13.6667 6.50351 12.2843 6.50391 10.7647V7.10469L11.3039 5.30469L16.1039 7.10469V10.7647C16.1039 12.2847 15.6515 13.6673 14.7467 14.9125C13.8419 16.1577 12.6943 16.9551 11.3039 17.3047ZM11.3039 16.0447C12.2739 15.7447 13.0839 15.1521 13.7339 14.2669C14.3839 13.3817 14.7639 12.3943 14.8739 11.3047H11.3039V6.57969L7.70391 7.92969V11.0347C7.70391 11.1047 7.71391 11.1947 7.73391 11.3047H11.3039V16.0447Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoFactor);
export default __webpack_public_path__ + "static/media/two-factor.e83dcd10af5dfae01621de9528b715e3.svg";
export { ForwardRef as ReactComponent };